import {
  POBillToPrimaryCategories,
  type POBillToPrimaryCategoryEnum,
} from '@webapp/platform/iam/entities/enums/POBillToPrimaryCategoryEnum'

const LOCATIONS: readonly POBillToPrimaryCategoryEnum[] = Object.values(
  POBillToPrimaryCategories
)

// The wire value is a plain int; anything outside the known set falls back
// to the default so an out-of-range preference can never leak an impossible
// enum member downstream.
export const mapPOBillToPrimaryCategoryApiModel = (
  value: number
): POBillToPrimaryCategoryEnum =>
  LOCATIONS.find((location) => location === value) ??
  POBillToPrimaryCategories.PURCHASER_HOME
